module.exports = __webpack_public_path__ + "static/img/Harry-Grant.a082530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harry-Grant.jpg
// module id = k099
// module chunks = 0